import { FC } from 'react';
import styled from 'styled-components';

export type StatusType = 'in-progress' | 'complete' | 'preview' | 'generated' | 'draft' | 'modified' | string;

interface StatusConfig {
  label: string;
  color: string;
  bg: string;
}

const STATUS_MAP: Record<string, StatusConfig> = {
  // project statuses
  'in-progress': { label: 'In Progress', color: '#2563eb', bg: '#eff6ff' },
  complete:      { label: 'Complete',    color: '#059669', bg: '#ecfdf5' },
  published:     { label: 'In Progress', color: '#2563eb', bg: '#eff6ff' },
  generated:     { label: 'Generated',   color: '#059669', bg: '#dcfce7' },
  draft:         { label: 'Draft',       color: '#92400e', bg: '#fef9c3' },
  modified:      { label: 'Modified',    color: '#1d4ed8', bg: '#dbeafe' },
  // template statuses
  preview:       { label: 'Coming Soon', color: '#d97706', bg: '#fffbeb' },
};

const Badge = styled.span<{ $color: string; $bg: string }>`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
  font-weight: 600;
  padding: 3px 9px;
  border-radius: 99px;
  align-self: flex-start;
  color: ${({ $color }) => $color};
  background: ${({ $bg }) => $bg};
  font-family: ${({ theme }) => theme?.fontFamily?.main ?? 'sans-serif'};
`;

const Dot = ({ color }: { color: string }) => (
  <svg width="5" height="5" viewBox="0 0 6 6" fill={color}>
    <circle cx="3" cy="3" r="3" />
  </svg>
);

interface NgStatusBadgeProps {
  status: StatusType;
}

export const NgStatusBadge: FC<NgStatusBadgeProps> = ({ status }) => {
  const config = STATUS_MAP[status];
  if (!config) return null;

  return (
    <Badge $color={config.color} $bg={config.bg}>
      <Dot color={config.color} />
      {config.label}
    </Badge>
  );
};
